import { render } from "./NotificationsOptions.vue?vue&type=template&id=4a5f4005"
import script from "./NotificationsOptions.vue?vue&type=script&lang=js"
export * from "./NotificationsOptions.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__